<template>
<div v-if="modal.isOpen.value" class="bg-wrapper">
  <div class="modal-overlay">

    <div class="">
      <p>{{ modal.message.value }}</p>

      <div class="actions">
        <button @click="modal.onConfirm">Conferma</button>
        <button @click="modal.onCancel">Annulla</button>
      </div>
    </div></div>
    </div>
</template>


<script setup lang="ts">
import { useModalService } from "../../services/ModalService";
const modal = useModalService();
</script>

<style>
.bg-wrapper{
  position: fixed;
  inset: 0; /* full screen */
  background: rgba(0, 0, 0, 0.5); /* <-- transparent gray */
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
   max-width: 90vw;
  top: 10vh;
  padding: 2rem;
  margin: 0 auto;
  background-color: rgba(255, 255, 255);
  box-shadow: 0 0.125rem 1.25rem 0 rgb(0 0 0 / 10%);
  color: var(--main-text-color);
  z-index: 999;
  border-radius: var(--rounded-box, 1rem);
  outline: none;
  border: none;

}
.modal-box {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
}
</style>
